export default __webpack_public_path__ + "static/media/consolidaded.97c62f59.png";